// Sidebar colapsable: items según el rol del user (admin > teacher > student).

import { NavLink } from 'react-router-dom';
import { Icon, type IconName } from '@/components/atoms/Icon';
import { useAuth } from '@/context/AuthContext';
import styles from './Sidebar.module.scss';

interface NavItem {
  to: string;
  label: string;
  icon: IconName;
  end?: boolean;
}

const STUDENT_ITEMS: NavItem[] = [
  { to: '/inicio',       label: 'Inicio',       icon: 'home', end: true },
  { to: '/reservas',     label: 'Mis reservas', icon: 'calendar' },
  { to: '/lecciones',    label: 'Lecciones',    icon: 'book' },
  { to: '/grammar-bank', label: 'Grammar Bank', icon: 'book-open-text' },
  { to: '/aula',         label: 'Aula',         icon: 'video' },
  { to: '/mis-notas',     label: 'Mis notas',     icon: 'notebook-pen' },
  { to: '/mis-feedbacks', label: 'Mis feedbacks', icon: 'star' },
  { to: '/perfil',        label: 'Perfil',        icon: 'user' },
];

const TEACHER_ITEMS: NavItem[] = [
  { to: '/inicio',              label: 'Inicio',            icon: 'home', end: true },
  { to: '/reservas',            label: 'Mis clases',        icon: 'calendar' },
  { to: '/disponibilidad',      label: 'Mi disponibilidad', icon: 'clock' },
  { to: '/grammar-bank',        label: 'Grammar Bank',      icon: 'book-open-text' },
  { to: '/aula',                label: 'Aula',              icon: 'video' },
  { to: '/profesor/feedbacks',  label: 'Feedbacks',         icon: 'star' },
  { to: '/informes',            label: 'Informes',          icon: 'bar-chart' },
  { to: '/perfil',              label: 'Perfil',            icon: 'user' },
];

const ADMIN_ITEMS: NavItem[] = [
  { to: '/inicio',           label: 'Inicio',       icon: 'home', end: true },
  { to: '/admin/usuarios',   label: 'Usuarios',     icon: 'users' },
  { to: '/lecciones',        label: 'Lecciones',    icon: 'book' },
  { to: '/grammar-bank',     label: 'Grammar Bank', icon: 'book-open-text' },
  { to: '/admin/vocabulary', label: 'Vocabulary',   icon: 'book' },
  { to: '/informes',         label: 'Informes',     icon: 'bar-chart' },
  { to: '/admin/emails',     label: 'Emails',       icon: 'mail' },
  { to: '/perfil',           label: 'Perfil',       icon: 'user' },
];

const INSPECTOR_ITEMS: NavItem[] = [
  { to: '/informes', label: 'Informes', icon: 'bar-chart', end: true },
  { to: '/perfil',   label: 'Perfil',   icon: 'user' },
];

function pickItems(roles: string[]): NavItem[] {
  if (roles.includes('admin')) return ADMIN_ITEMS;
  if (roles.includes('teacher')) return TEACHER_ITEMS;
  if (roles.includes('inspector') || roles.includes('company_admin')) return INSPECTOR_ITEMS;
  return STUDENT_ITEMS;
}

export function Sidebar() {
  const { state } = useAuth();
  const roles = state.status === 'authenticated' ? state.user.roles : [];
  const items = pickItems(roles);
  return (
    <aside className={styles.sidebar} aria-label="Navegación principal">
      <div className={styles.brand}>
        <span className={styles.logo}>K</span>
        <span className={styles.brandText}>Knooowy</span>
      </div>
      <nav className={styles.nav}>
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
            aria-label={item.label}
          >
            <span className={styles.iconBox}><Icon name={item.icon} size={20} /></span>
            <span className={styles.label}>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
